import React from 'react';
import { View, Text, StyleSheet, ScrollView } from 'react-native';
import { theme } from '../constants/theme';
import { hp, wp } from '../helpers/common';
import BackButton from './BackButton';

interface AuthScreenTemplateProps {
  title: string;
  subtitle: string;
  goBack: () => void;
  children: React.ReactNode;
}

const AuthScreenTemplate: React.FC<AuthScreenTemplateProps> = ({
  title,
  subtitle,
  goBack,
  children,
}) => {
  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      <View style={styles.header}>
        <BackButton navigation={{ goBack }} />
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.subtitle}>{subtitle}</Text>
      </View>
      <View style={styles.content}>
        {children}
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.white,
  },
  header: {
    paddingHorizontal: wp(4),
    paddingTop: hp(2),
    paddingBottom: hp(3),
  },
  title: {
    fontSize: hp(2.5),
    fontWeight: 'bold',
    color: theme.colors.dark,
    marginTop: hp(2),
    textAlign: 'center',
  },
  subtitle: {
    fontSize: hp(1.8),
    color: theme.colors.text,
    marginTop: hp(1),
    textAlign: 'center',
    lineHeight: hp(2.2),
  },
  content: {
    flex: 1,
    paddingHorizontal: wp(4),
  },
});

export default AuthScreenTemplate;
